import { FormFieldValidator, ValidationResult } from './FormFieldValidator';
import { CustomerIdAndOrderIdIntegrityResponse } from '../../../services/connectors/CustomerIdAndOrderIdIntegrityResponse';
import { ContactFormConnector } from '../../../services/connectors/ContactFormConnector';
import { FormFieldValue, OrderCompositeField } from '../types';

export class OrderNumberValidator extends FormFieldValidator {
  constructor(private readonly isUserLoggedIn: boolean) {
    super(true);
  }

  async validate(value: FormFieldValue): Promise<ValidationResult> {
    const orderId =
      (value as OrderCompositeField).orderId.trim().length > 0
        ? (value as OrderCompositeField).orderId
        : null;
    const suborderId =
      (value as OrderCompositeField).suborderId.trim().length > 0
        ? (value as OrderCompositeField).suborderId
        : null;
    if (!this.requiredCheck(value)) {
      return ValidationResult.create(this.isEmpty(value));
    }

    if (!this.isUserLoggedIn) {
      return ValidationResult.create(true);
    }

    return this.requestAsyncValidation(orderId, suborderId)
      .then((result: CustomerIdAndOrderIdIntegrityResponse) => {
        return this.serviceResponseToValidationResult(result);
      })
      .catch((e) => {
        console.log('Error occurred on Order ID validation', e);
        return ValidationResult.create(true);
      });
  }

  async requestAsyncValidation(orderId: string, suborderId: string) {
    return new ContactFormConnector().validateOrderIdV2(orderId, suborderId);
  }
  protected serviceResponseToValidationResult(
    response: CustomerIdAndOrderIdIntegrityResponse,
  ): ValidationResult {
    const isValid = response.isOrderIdValid;
    const errorTags = isValid ? [] : ['order_id_invalid'];
    return ValidationResult.create(isValid, errorTags);
  }
}
